export default __webpack_public_path__ + "static/media/fineart_text_xl.b5008190.svg";